import { format, parse } from "date-fns";

export const parseRvDate = (forMonth: string, toFormat = "MMM, yyyy") =>
  format(parse(forMonth, "yyyy-MM-dd", new Date()), toFormat);
